import { apiClient } from "@/lib/api/client";
import type { ActionCreateDto, ActionDto } from "@/lib/api/types";

export async function listActions(tenantId: string): Promise<ActionDto[]> {
  const { data } = await apiClient.get<ActionDto[]>("/actions", { params: { tenant_id: tenantId } });
  return data;
}

export async function createAction(body: ActionCreateDto): Promise<ActionDto> {
  const { data } = await apiClient.post<ActionDto>("/actions", body);
  return data;
}
